module.exports = __webpack_public_path__ + "static/img/sign-language-train_2x.6ed1f94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/signLanguage/sign-language-train_2x.png
// module id = hzHm
// module chunks = 1